import type { LoginTr } from "./useLoginTranslations";

export type AuthBrandMode =
  | "signup"
  | "login"
  | "forgotPassword"
  | "verifyEmail"
  | "pendingApproval"
  | "deactivated"
  | "mfaChallenge"
  | "revertMfa";

interface AuthBrandCopy {
  headline: string;
  body: string;
}

export function getAuthBrandCopy(mode: AuthBrandMode, tr: LoginTr): AuthBrandCopy {
  switch (mode) {
    case "signup":
      return {
        headline: tr("login.brand.signupHeadline", "Your team knows things you don't know yet."),
        body: tr(
          "login.brand.signupBody",
          "Surface what people really think — anonymously — and turn it into themes you can act on.",
        ),
      };
    case "forgotPassword":
      return {
        headline: tr("login.brand.forgotHeadline", "It happens. Let's get you back in."),
        body: tr(
          "login.brand.forgotBody",
          "We'll send a secure reset link to your work email. No password needed to start.",
        ),
      };
    case "verifyEmail":
      return {
        headline: tr("login.brand.verifyHeadline", "Almost there."),
        body: tr("login.brand.verifyBody", "Confirm your email to activate your Collective Discovery account."),
      };
    case "pendingApproval":
      return {
        headline: tr("login.brand.pendingHeadline", "We're reviewing your account."),
        body: tr("login.brand.pendingBody", "Your email is confirmed. We'll notify you when your account is ready."),
      };
    case "deactivated":
      return {
        headline: tr("login.brand.deactivatedHeadline", "This account is inactive."),
        body: tr("login.brand.deactivatedBody", "Contact your administrator or support if you need access restored."),
      };
    case "mfaChallenge":
      return {
        headline: tr("login.brand.mfaHeadline", "One more step."),
        body: tr("login.brand.mfaBody", "Open the app on your phone and enter the code to finish signing in."),
      };
    case "revertMfa":
      return {
        headline: tr("login.brand.revertMfaHeadline", "Keep your account safe."),
        body: tr("login.brand.revertMfaBody", "Remove a 2-step verification method you didn't add yourself."),
      };
    default:
      return {
        headline: tr("login.brand.loginHeadline", "A steady hand in uncertain water."),
        body: tr(
          "login.brand.loginBody",
          "Pick up where you left off — your sessions, themes and findings are right where you need them.",
        ),
      };
  }
}
